module.exports = __webpack_public_path__ + "static/media/barchart.68f1fa3d.svg";